export type InPageSurveyAnswerStatus = 'NOT_YET' | 'DONE' | 'SKIP';

const NOT_YET = 'NOT_YET';
const DONE = 'DONE';
const SKIP = 'SKIP';

export const inPageSurveyAnswerStatus: {
  NOT_YET: InPageSurveyAnswerStatus;
  DONE: InPageSurveyAnswerStatus;
  SKIP: InPageSurveyAnswerStatus;
} = {
  NOT_YET,
  DONE,
  SKIP,
};
